export default __webpack_public_path__ + "static/media/edit-page.be0d3f61.svg";